export const fullName = (firstName?: string, lastName?: string): string => {
  return `${firstName ?? ''} ${lastName ?? ''}`.trim()
}
